import React from 'react';
import TextField from '@mui/material/TextField';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LOOKUP from 'constants/lookup';
import TextInput from 'screens/components/basic/TextInput';
import SelectInput from 'screens/components/basic/SelectInput';
import Button from 'screens/components/basic/Button';
import CardSimple from 'screens/components/basic/CardSimple';

const statusOptions = [
    {
        text: "All",
        value: "None"
    },
    {
        text: "Active",
        value: "1"
    },
    {
        text: "Inactive",
        value: "2"
    }
];

const typeOptions = [
    {
        text: "All",
        value: "0"
    },
    {
        text: "Bulk",
        value: "1"
    },
    {
        text: "Unit",
        value: "2"
    },
    {
        text: "Pre-Pack",
        value: "3"
    }
];

const imageOptions = [
    {
        text: "All",
        value: "0"
    },
    {
        text: "Yes",
        value: "1"
    },
    {
        text: "No",
        value: "2"
    }
];

const descriptionOptions = [
    {
        text: "All",
        value: "0"
    },
    {
        text: "Yes",
        value: "1"
    },
    {
        text: "No",
        value: "2"
    }
];

const eliteOptions = [
    {
        text: "All",
        value: "0"
    },
    {
        text: "Elite Only",
        value: "1"
    },
    {
        text: "Non-Elite Only",
        value: "2"
    }
];


const searchFields = (props) => {
    return (
        <CardSimple className="mb-2">
            <div className="row p-0">
            {/*Search Inputs*/}
                <div className="col-sm-4">
                    <TextInput
                        name={`${props.pageName}SkuNumberFilter`}
                        className="search-field"
                        hintText={LOOKUP.product.filters.skuNumber.hintText}
                        onPressKey={props.search}
                        label={LOOKUP.product.filters.skuNumber.label}
                        floatingLabelText={LOOKUP.product.filters.skuNumber.label}
                    />
                </div>
                <div className="col-md-4 col-sm-6">
                    <TextInput
                        name={`${props.pageName}NameFilter`}
                        className="search-field"
                        hintText={LOOKUP.product.filters.name.hintText}
                        onPressKey={props.search}
                        label={LOOKUP.product.filters.name.label}
                        floatingLabelText={LOOKUP.product.filters.name.label}
                    />
                </div>
                <div className="col-md-4 col-sm-6">
                    <SelectInput
                        name={`${props.pageName}CategoryFilter`}
                        fullWidth={true}
                        className="search-field"
                        floatingLabelText={LOOKUP.product.filters.category.label}
                        options={props.categories}
                        hintText={LOOKUP.product.filters.category.hintText}
                        defaultValue="0" />
                </div>
                <div className="col-md-4 col-sm-6">
                    <SelectInput name={`${props.pageName}PriceMatrix`}
                        fullWidth={true}
                        className="search-field"
                        floatingLabelText={LOOKUP.product.priceMatrix.label}
                        options={props.priceMatrices}
                        hintText={LOOKUP.product.priceMatrix.hintText}
                        defaultValue="0" />
                </div>
                <div className="col-md-4 col-sm-6">
                    <SelectInput
                        name={`${props.pageName}Status`}
                        className="search-field"
                        label="Status"
                        floatingLabelText="Status"
                        defaultValue="None"
                        options={statusOptions} />
                </div>
                <div className="col-md-4 col-sm-6">
                    <SelectInput
                        name={`${props.pageName}Type`}
                        className="search-field"
                        label="Type"
                        floatingLabelText="Type"
                        defaultValue="0"
                        options={typeOptions}
                    />
                </div>
                <div className="col-md-4 col-sm-6">
                    <SelectInput
                        name={`${props.pageName}HasImage`}
                        className="search-field"
                        label="Image Available"
                        floatingLabelText="Image Available"
                        defaultValue="0"
                        options={imageOptions}
                    />
                </div>
                <div className="col-md-4 col-sm-6">
                    <SelectInput
                        name={`${props.pageName}HasDescription`}
                        className="search-field"
                        label="Description Available"
                        floatingLabelText="Description Available"
                        defaultValue="0"
                        options={descriptionOptions}
                    />
                </div>
                {
                    props.isHighTide &&
                    <div className="col-md-4 col-sm-6">
                        <SelectInput
                            name={`${props.pageName}EliteFilter`}
                            className="search-field"
                            label="EliteFilter"
                            floatingLabelText="EliteFilter"
                            defaultValue="0"
                            options={eliteOptions}
                        />
                    </div>
                }
                <div className="col-md-4 col-sm-6">
                    <TextInput
                        name={`${props.pageName}UniversalProductCode`}
                        className="search-field"
                        hintText="Universal Product Code"
                        label="Universal Product Code"
                        floatingLabelText="Universal Product Code"
                    />
                </div>
            <div className="col-md-4 col-sm-6">
                <TextInput
                    name={`${props.pageName}ProductCode`}
                    className="search-field"
                    hintText="Product Code"
                    label="Product Code"
                    floatingLabelText="Product Code"
                />
            </div>
            </div>
            {/*Buttons*/}
            <div className="row mt-2">
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <p className="purpleText font-italic">
                        <b>Note: </b>The price <b>"$999"</b> is the <b>default</b> price for all products in our system.
                    </p>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 d-flex pb-2 justify-content-end'>
                    <Button
                        type="IconInButton"
                        className="btnNewBrandPOS mr-2"
                        id="downloadProductList"
                        label={LOOKUP.report.common.downloadProductList.label}
                        icon={<VisibilityIcon />}
                        onTouchTap={props.downloadProductList} />
                    <Button
                        className="btnCleanSearchS mr-2"
                        type="IconClearButton"
                        label={LOOKUP.product.filters.cleanFilterButton}
                        labelPosition="before"
                        onTouchTap={props.cleanSearch} />
                    <Button
                        className="btnNewBrandPOS"
                        type="IconSearchButton"
                        id="searchProduct"
                        labelPosition="before"
                        mini={true}
                        label={LOOKUP.product.filters.filterButton}
                        backgroundColor={"#6C59B9"}
                        onTouchTap={props.search} />
                </div>
            </div>
        </CardSimple>
    );
};


export default searchFields;